import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as SpreadsheetTableDataItem } from '@/components/tables/SpreadsheetTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  spreadsheetItem: ReadonlyDeep<openapi.PostJobBookXls_201['booked'][0]>,
): SpreadsheetTableDataItem {
  const jobId = spreadsheetItem.rh_id;
  const jobDate = spreadsheetItem.rh_date;

  return {
    jobId,
    jobDate,
    customerCode: getStrCell(spreadsheetItem.customer_code),
    reference1: getStrCell(spreadsheetItem.REF1),
    reference2: getStrCell(spreadsheetItem.REF2),
    stop1name: getStrCell(spreadsheetItem.stops[0].name),
    stop1suburb: getStrCell(spreadsheetItem.stops[0].suburb),
    stop1state: getStrCell(spreadsheetItem.stops[0].state),
    stop2name: getStrCell(spreadsheetItem.stops[1].name),
    stop2suburb: getStrCell(spreadsheetItem.stops[1].suburb),
    stop2state: getStrCell(spreadsheetItem.stops[1].state),
  };
}

export function getTableData(
  spreadsheetData:
    | ReadonlyDeep<openapi.PostJobBookXls_201['booked']>
    | undefined,
): SpreadsheetTableDataItem[] {
  const _spreadsheetData: SpreadsheetTableDataItem[] = [];
  if (!spreadsheetData?.length) {
    return _spreadsheetData;
  }
  spreadsheetData.forEach(function (spreadsheetItem) {
    _spreadsheetData.push(getTableItem(spreadsheetItem));
  });
  return _spreadsheetData;
}
